import bsMessages from '../locales/bs_BA';

const BsLang = {
  messages: {
    ...bsMessages,
  },
  locale: 'bs-BA',
};
export default BsLang;
